// extracted by mini-css-extract-plugin
export var linkText = "_r1-0";